/* @flow */
/**
 * Internal dependencies
 */
import {
	ADD_ANSWER,
	INCREMENT_PROGRESS,
	USER_CONFIRM_SOUND,
	USER_SET_GENDER,
	USER_SET_PIN,
	USER_SET_TRACK,
} from '../constants/action-types';

/**
 * Set Pin
 */
export type UserSetPinAction = {
	type: typeof USER_SET_PIN;
	payload: string;
};

export const setPin = ( payload: string ) : UserSetPinAction => {
	return {
		type: USER_SET_PIN,
		payload,
	};
};

/**
 * Set Track
 */
export type UserSetTrackAction = {
	type: typeof USER_SET_TRACK;
	payload: string;
};

export const setTrack = ( payload: string ) : UserSetTrackAction => {
	return {
		type: USER_SET_TRACK,
		payload,
	};
};

/**
 * Set Gender
 */
export type UserSetGenderAction = {
	type: typeof USER_SET_GENDER;
	payload: 'male' | 'female';
};

export const setGender = ( payload: 'male' | 'female' ) : UserSetGenderAction => {
	return {
		type: USER_SET_GENDER,
		payload,
	};
};

/**
 * Confirm sound
 */
export type UserConfigSoundAction = {
	type: typeof USER_CONFIRM_SOUND;
};

export const confirmSound = () : UserConfigSoundAction => {
	return {
		type: USER_CONFIRM_SOUND,
	};
};

/**
 * Add answer to array
 */
export type UserAddAnswerAction = {
	type: typeof ADD_ANSWER;
	payload: any;
};

export const addAnswer = ( payload: any ) : UserAddAnswerAction => {
	return {
		type: ADD_ANSWER,
		payload,
	};
};

/**
 * Increment progress
 */
export type UserIncrementProgressAction = {
	type: typeof INCREMENT_PROGRESS;
}

export const incrementProgress = () : UserIncrementProgressAction => {
	return {
		type: INCREMENT_PROGRESS,
	};
};



// WEBPACK FOOTER //
// ./src/actions/user.js